import React from 'react';

const PricingPersonaHero = ({ eyebrow, dotColor, title, subtitle, primaryCta, secondaryCta }) => (
    <section className="lp-pricing-hero">
        <div className="lp-hero-glow lp-glow-anim" aria-hidden="true" />
        <div className="lp-pricing-hero-inner">
            <div className="lp-eyebrow-pill" data-lp-reveal>
                <span style={{ background: dotColor }} />
                <span style={{ color: dotColor }}>{eyebrow}</span>
            </div>
            <h1 className="lp-h1" style={{ margin: '0 0 16px' }} data-lp-reveal data-lp-delay="60">{title}</h1>
            <p className="lp-lead" style={{ maxWidth: '640px', margin: '0 auto 30px' }} data-lp-reveal data-lp-delay="120">{subtitle}</p>
            <div className="lp-cta-row" style={{ justifyContent: 'center' }} data-lp-reveal data-lp-delay="180">
                <a className="lp-btn lp-btn--primary" style={{ borderRadius: '50px' }} href={primaryCta.href}>{primaryCta.text}</a>
                <a className="lp-btn lp-btn--pe-outline" style={{ borderRadius: '50px' }} href={secondaryCta.href}>{secondaryCta.text}</a>
            </div>
        </div>
    </section>
);

export default PricingPersonaHero;
